import React from "react";
import { css } from "emotion";
import TargetingTypeItem from "./TargetingTypeItem";

const SelectTargetingTypeList = ({lastLocation}) => {
  const targetingTypes = [
    {
      title: 'Pages / URLs',
      subtitle: 'Display this spotlight to visitors on specific pages of your website.',
      route: 'targeting/pages',
      planNeeded: 'free',
    },
    {
      title: 'UTM Parameter Targeting',
      subtitle: 'Display this spotlight to visitors based on UTM parameters.',
      route: 'targeting/utm',
      planNeeded: 'premium',
    },
    {
      title: 'Query String Parameters',
      subtitle: 'Display this spotlight to visitors based on query string parameters.',
      route: 'targeting/query-strings',
      planNeeded: 'premium',
    },
  ];

  return (
    <div className={container}>
      {targetingTypes.map((item) => (
        <TargetingTypeItem key={item.title} item={item} lastLocation={lastLocation} />
      ))}
    </div>
  );
};

export default SelectTargetingTypeList;

const container = css`
  align-self: flex-start;
  margin-top: 0 !important;
`;
